// eslint-disable-next-line import/no-extraneous-dependencies
import { ObjectWithObjectID } from '@algolia/client-search';
import algoliasearch from 'algoliasearch';
import invariant from 'invariant';
import queryString from 'query-string';

import { configValue } from 'config/appConfigUtils';
import { RichError } from 'utils/RichError';
import { getJson } from 'utils/http';
import { trackError } from 'utils/trackError';

import {
  AlgoliaApiValidUntilError,
  isValidUntilError,
} from './AlgoliaApiValidUntilError';

type Args = {
  config: Readonly<{ appId: string; apiKey: string }>;
  index: string;
  id: string;
  attributes: Array<string>;
};

export async function algoliaApiGetObject<T>({
  config: { appId, apiKey },
  index,
  id,
  attributes,
}: Args): Promise<void | (T & ObjectWithObjectID)> {
  if (configValue('algolia', 'mock')) {
    return getJson<{ object: T & ObjectWithObjectID }>(
      `http://algoliamock:6577/${index}/objects/${id}`,
    ).then((response) => {
      if (response.object !== null) {
        return response.object;
      }
      throw new Error('Object not found');
    });
  }
  invariant(appId, 'Search app id must be configured');
  invariant(apiKey, 'Search api key must be configured');
  const client = algoliasearch(appId, apiKey);
  const indexClient = client.initIndex(index);

  try {
    const response = await indexClient.getObject<T>(id, {
      attributesToRetrieve: attributes,
    });

    return response;
    // TODO: fix types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    if (isValidUntilError(e)) {
      throw new AlgoliaApiValidUntilError();
    }

    trackError(
      new RichError('Algolia POST request error.', {
        debugData: e.debugData,
        errorMessage: e.message,
        requestParams: queryString.stringify({
          id,
          attributes,
        }),
        statusCode: e.statusCode,
        response: e.response,
      }),
    );
  }
}
